import { createContext } from "react";

export const DraggableListContext = createContext({});
